// extracted by mini-css-extract-plugin
module.exports = {"iframe":"IFrame_iframe__Yv4q7","btn":"IFrame_btn__iZmnt","scaledFrame":"IFrame_scaledFrame__1l5pH"};